var Marionette = require('marionette'),
    BaseContainer = require('../baseModeContainer'),
    $ = require('jquery'),
    DocPgImgWr = require('../../page/docMode/pageDocMode'),
    UnRenderablePg = require('../../page/unRenderable/unrenderablePg').document,
    UrlPg = require('../../page/url/view');

require('jqDragScroller');
require('jqLazyLoad');


// Note: common code with thumb-mode container here


module.exports = Marionette.CompositeView.extend({

    lazyLoadDelay: 200,   // Delay also prevents from loading too many images
    scrollThrottle: 200,  // There is also a queue of max images to load

    constructor: function(options) {

        // Prevent need to pass in option -- greatly optimizes for pages with large documents
        this.sort = false;

        // From old initialize:
        _.extend( this, BaseContainer );

        this.scale = {};
        this.collection = options.collection;
        this.lastScrollTop = 0;
        this.pageChangedFromScroll = false;  // Leave here for now: this needs cleanup --

        Marionette.CompositeView.prototype.constructor.apply( this, arguments );

    },

    getChildView: function(model) {
        
        if ( model.renderUrlViewForDocAndPageMode() ) {
            return UrlPg;
        } else {
            return model.isRenderable()
                ? DocPgImgWr
                : UnRenderablePg;
        }
        
    },
    template:  require('../modeContainer.hbs'),
    childViewContainer: '.FV-paneContent',
    childViewOptions: function() {
        return {
            scale: this.scale,
            vChannel: this.options.vChannel
        };
    },

    serializeData: function() {
        return {
            docOrPg: 'doc'
        };
    },

    /* Override Render Children (Don't Yet know Scale */
    render: function() {
        this._ensureViewIsIntact();
        this.isRendered = true;
        this.resetChildViewContainer();
        this.triggerMethod('before:render', this);
        this._renderTemplate();
        this.triggerMethod('render', this);
        return this;
    },
    onRender: function() {
        this.unwrap();
        this.$el.scrollTop(0).dragScoller(); // note: onShow used in WF promise -- must use here
    },

    /* when called from viewer, vOffsets are now set */
    onRenderPages: function(scale) {

        this.scale = scale; // must set for childView options
        this._renderChildren();

        // DVBC-1444: ensure the current page is scrolled to on load after viewer reset from pages added/deleted
        this.scrollToCurrentPageTop();

        // Apply lazy load plugin in bulk to all the element  -- DOM related
        // Note: this.$ would work --
        // could filter for renderable children ...
        $(this.children.pluck('el')).lazyLoad({
            container: this.$el,
            delay: this.lazyLoadDelay,
            skipClass: 'invisible'
        });

        this.checkForPagesInView();

    },
    events: {
        'scroll': 'scrollCB'
    },
    scrollCB: function(e) {
        this.options.vChannel.command('forceClosePageActionDropdownMenus'); // could just call if any of them open
        _.throttle(this.pageScrollThresholdCheck(e), this.scrollThrottle) ;
    },
    scrollToCurrentPageTop: function() {

        var vCh = this.options.vChannel;

        /**
         *  Commenting out exiting the routine if viewer not loaded to allow for scrolling
         *  to the current page if it isn't the first in the document.
         *  Perf. downside minimal, which is probably why put in, in the first place.
         *  On load process, this is called from callbacks in 'postScaleChange' event listeners.
         *  Perhaps better to call explicitly -- if so, appears should call at the end of this.onRenderPages
         *  (page vOffsets are set immediately after it is called)
         */
        //if ( !vCh.request('viewerLoaded')) return;


        // this is coming from the scroll event check
        if ( this.pageChangedFromScroll ) {
            this.pageChangedFromScroll = false; //set the variable back here: AFTER THE PAGE HAS CHANGED !
            return;
        }

        // Leave for now : don't scroll more is already scrolling by grab --
        // The page number change is still set by this view's events
        // TODO: uncouple the data attribute
        if (this.$el.data('dragging') === true)
            return;

        this.$el.scrollTop(
            this.children.findByModel( vCh.request('currentPage')).$el.position().top
        );

    },
    checkForPagesInView: function() {
        var allowImagesToLoad =  this.options.vChannel.request('loadImages');
        allowImagesToLoad && this.$el.trigger('checkInView');
    },

    // Used to see if should move to next/prev page after a scroll event (if we pass a threshold )
    // The 'OLD' prob is when it can never get there!
    pageScrollThresholdCheck: function() {

        var currentScrollTop = this.$el.scrollTop(),
            dy = currentScrollTop - this.lastScrollTop,
            vCh = this.options.vChannel;

        this.lastScrollTop = currentScrollTop;

        if ( dy === 0 ) {
            return;
        }

        if (dy > 0) { // scrolldown

            var currentPgScrollThreshold =  vCh.request('currentPage').get('vOffset');
            if (currentScrollTop > currentPgScrollThreshold) {

                var nextPage = vCh.request('nextPage');
                if (nextPage) { // if not on last page -- trigger to change the current page to the next
                    this.pageChangedFromScroll = true;
                    vCh.command('goToPage', nextPage);
                }
            }

        }  else if (dy < 0) { //scrollup : dy would be negative

            var prevPg = vCh.request('prevPage');
            if (prevPg) {

                // When most of first page visible -- scroll  -- this fixes for now!  (I think need the padding amt)
                // Rounding issues, can't get around here; err on the side of this not being the case -- 10 is a buffer for now  (see above)
                var prevPgThreshold = prevPg.get('vOffset') - Math.round((this.$el.height()/2)) - 10;

                if (currentScrollTop < prevPgThreshold) {
                    this.pageChangedFromScroll = true;
                    vCh.command('goToPage', prevPg);
                }
            }
        }
    },

    /**
     * TODO: pass from mediator with vars .. clean -- pass scale Model and other params here? -- higher up
     * (has already changed)
     * First check if scale is fit-height, if so, set the scale prior to changing the page.
     * Need to do this for pages of var height (now using actual heights )
     */
    onChangePage: function(options) {

        var vCh = this.options.vChannel;

        if ( this.scale.scaledTypeIsDerived() ) {

            if (!this.pageChangedFromScroll) {  // changed from scroll, don't set scale (time being) -- during this process, things may have changed from scroll

                vCh.command('setScale');
                this.scrollToCurrentPageTop();

            } else {

                //still must scroll to page if not from scroll  -- sets the pg and calls events ( from scroll enter? )
                this.scrollToCurrentPageTop();
            }

        } else {

            this.scrollToCurrentPageTop();
        }

        options.loadImages &&
            vCh.command('handleDocModeImgPrefetching', vCh.request('currentPage'));

    },

    postScaleChange: function(scale, prevScale, options) {

        var fromPageRotation = options && options.fromRotation;

        this.children.call('updateViewPort', scale);

        // TODO: this should be moved up
        // ... do immediatley post change change to get the new offsets  ???
        this.collection.setVOffsets(scale); // need to update the offsets for scrolling after the scale change

        // I think we want if from rotation so commenting out; forgot why was put in ...
        // If not could rotate, and then appear to be on a different page
        //if ( !fromPageRotation )
            this.scrollToCurrentPageTop();

        if ( (scale < prevScale) || fromPageRotation )
            this.checkForPagesInView();

    },

    onBeforeDestroy: function() {
        this.$el.destroyDragScroller();
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewModes/docMode/docModeContainer.js
 ** module id = 414
 ** module chunks = 0
 **/